/**
 * Pinterest Event Tracking
 * - InitiateCheckout: 跟踪用户点击结账按钮时触发
 * - Checkout: 跟踪用户完成购买时触发（订单确认页面）
 */

(function() {
  'use strict';

  // 检查 Pinterest 标签是否已加载
  function isPinterestLoaded() {
    return typeof window.pintrk !== 'undefined';
  }

  // 从页面获取购物车数据
  function getCartDataFromPage() {
    try {
      const cartScript = document.querySelector('#json-cart[type="application/json"]') ||
                        document.querySelector('#json-cart-drawer[type="application/json"]') ||
                        document.querySelector('[id^="json-cart"][type="application/json"]');
      if (cartScript) {
        return JSON.parse(cartScript.textContent);
      }
    } catch (error) {
      console.error('Error parsing cart data:', error);
    }
    return null;
  }

  // 等待 Pinterest 标签加载
  function waitForPinterestTag(callback, maxAttempts) {
    maxAttempts = maxAttempts || 30;
    let attempts = 0;
    
    function check() {
      attempts++;
      if (isPinterestLoaded()) {
        callback(true);
        return;
      }
      
      if (attempts >= maxAttempts) {
        callback(false);
        return;
      }
      
      setTimeout(check, 100);
    }
    
    check();
  }

  // 触发 InitiateCheckout 事件（使用标准 API）
  function trackInitiateCheckoutSync(cartData) {
    if (!isPinterestLoaded() || !cartData || !cartData.items || cartData.items.length === 0) {
      return false;
    }

    const value = cartData.total_price ? (cartData.total_price / 100) : 0;
    const currency = cartData.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    try {
      window.pintrk('track', 'InitiateCheckout', {
        value: value,
        currency: currency,
        order_quantity: cartData.item_count || cartData.items.length
      });
      return true;
    } catch (error) {
      console.error('Error tracking Pinterest event:', error);
      return false;
    }
  }

  // 使用 fetch 作为备用方案（如果 Pinterest 标签未加载）
  function trackInitiateCheckoutWithFetch(cartData) {
    if (!cartData || !cartData.items || !cartData.items.length) {
      return false;
    }

    try {
      // 获取 Pinterest Tag ID
      let tid = '2613844295748';
      if (window.pintrk && window.pintrk.tid) {
        tid = window.pintrk.tid;
      }

      const value = cartData.total_price ? (cartData.total_price / 100) : 0;
      const currency = cartData.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

      // 构建事件数据
      const eventData = {
        event_name: 'InitiateCheckout',
        event_time: Math.floor(Date.now() / 1000),
        value: value,
        currency: currency,
        order_quantity: cartData.item_count || cartData.items.length
      };

      // 构建 URL
      const cb = Date.now();
      const url = 'https://ct.pinterest.com/v3/?cb=' + cb + 
                  '&event=InitiateCheckout&tid=' + tid + 
                  '&ed=' + encodeURIComponent(JSON.stringify(eventData));

      // 使用 fetch with keepalive 确保在页面跳转前发送
      // sendBeacon 不能发送 GET 请求，所以使用 fetch
      fetch(url, { 
        method: 'GET', 
        keepalive: true,
        mode: 'no-cors' // 使用 no-cors 避免 CORS 问题
      }).catch(function(err) {
        console.error('Failed to send Pinterest event:', err);
      });

      return true;
    } catch (error) {
      console.error('Error sending Pinterest event:', error);
      return false;
    }
  }

  // 发送 InitiateCheckout 事件
  function sendInitiateCheckoutEvent() {
    let cartData = getCartDataFromPage();
    
    if (!cartData) {
      // 已关闭：避免额外请求 /cart.js 导致 429。如需恢复，取消下方注释即可。
      // fetch('/cart.js')
      //   .then(function(response) {
      //     return response.json();
      //   })
      //   .then(function(data) {
      //     sendEventWithCartData(data);
      //   })
      //   .catch(function(error) {
      //     console.error('Failed to fetch cart data:', error);
      //   });
      return;
    }
    
    sendEventWithCartData(cartData);
  }

  // 使用购物车数据发送事件
  function sendEventWithCartData(data) {
    // 优先使用标准 API
    if (isPinterestLoaded()) {
      trackInitiateCheckoutSync(data);
      return;
    }
    
    // 如果标签未加载，快速等待（最多 500ms）
    waitForPinterestTag(function(loaded) {
      if (loaded) {
        trackInitiateCheckoutSync(data);
      } else {
        // 超时后使用 fetch 作为备用
        trackInitiateCheckoutWithFetch(data);
      }
    }, 5); // 只等待 500ms（5 * 100ms），确保不延迟跳转
  }

  // 设置结账按钮监听
  function setupCheckoutTracking() {
    // 监听购物车页面表单提交
    const cartForm = document.getElementById('cart-form');
    if (cartForm) {
      cartForm.addEventListener('submit', function(event) {
        const checkoutButton = event.submitter || document.querySelector('button[name="checkout"]');
        if (checkoutButton && checkoutButton.name === 'checkout') {
          sendInitiateCheckoutEvent();
        }
      }, true);
    }

    // 监听购物车抽屉表单提交
    const cartDrawerForm = document.getElementById('cart-drawer-form');
    if (cartDrawerForm) {
      cartDrawerForm.addEventListener('submit', function(event) {
        const checkoutButton = event.submitter || document.querySelector('button[name="checkout"]');
        if (checkoutButton && checkoutButton.name === 'checkout') {
          sendInitiateCheckoutEvent();
        }
      }, true);
    }

    // 监听结账按钮点击（作为备用）
    document.addEventListener('click', function(event) {
      const checkoutButton = event.target.closest('button[name="checkout"]');
      if (checkoutButton && !checkoutButton.disabled) {
        // 在点击时立即发送事件，不阻止默认行为
        sendInitiateCheckoutEvent();
      }
    }, true);
  }

  // 初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCheckoutTracking);
  } else {
    setupCheckoutTracking();
  }

  // 购物车更新时重新设置
  if (typeof window.subscribe !== 'undefined' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function() {
      setTimeout(setupCheckoutTracking, 100);
    });
  }

  // ============================================
  // Checkout 事件跟踪（订单确认页面）
  // ============================================

  // 触发 Checkout 事件（使用标准 API）
  function trackCheckoutSync(orderData) {
    if (!isPinterestLoaded() || !orderData) {
      return false;
    }

    const value = orderData.total_price ? (orderData.total_price / 100) : 0;
    const currency = orderData.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const orderId = orderData.order_id || orderData.order_number || '';

    try {
      window.pintrk('track', 'Checkout', {
        value: value,
        currency: currency,
        order_id: orderId,
        order_quantity: orderData.item_count || (orderData.line_items && orderData.line_items.length) || 1
      });
      return true;
    } catch (error) {
      console.error('Error tracking Pinterest Checkout event:', error);
      return false;
    }
  }

  // 使用 fetch 作为备用方案
  function trackCheckoutWithFetch(orderData) {
    if (!orderData) {
      return false;
    }

    try {
      let tid = '2613844295748';
      if (window.pintrk && window.pintrk.tid) {
        tid = window.pintrk.tid;
      }

      const value = orderData.total_price ? (orderData.total_price / 100) : 0;
      const currency = orderData.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      const orderId = orderData.order_id || orderData.order_number || '';

      const eventData = {
        event_name: 'Checkout',
        event_time: Math.floor(Date.now() / 1000),
        value: value,
        currency: currency,
        order_id: orderId,
        order_quantity: orderData.item_count || (orderData.line_items && orderData.line_items.length) || 1
      };

      const cb = Date.now();
      const url = 'https://ct.pinterest.com/v3/?cb=' + cb + 
                  '&event=Checkout&tid=' + tid + 
                  '&ed=' + encodeURIComponent(JSON.stringify(eventData));

      fetch(url, { 
        method: 'GET', 
        keepalive: true,
        mode: 'no-cors'
      }).catch(function(err) {
        console.error('Failed to send Pinterest Checkout event:', err);
      });

      return true;
    } catch (error) {
      console.error('Error sending Pinterest Checkout event:', error);
      return false;
    }
  }

  // 检测并发送 Checkout 事件
  function checkAndTrackCheckout() {
    // 检查是否是订单确认页面
    // Shopify 订单确认页面通常在 checkout.shopify.com 域名下
    const isCheckoutPage = window.location.hostname.includes('checkout.shopify.com') ||
                          window.location.hostname.includes('checkout.shopifycs.com') ||
                          window.location.pathname.includes('/checkout/thank_you') ||
                          window.location.pathname.includes('/checkout/thank-you') ||
                          window.location.pathname.match(/\/orders\/[^\/]+/) ||
                          document.querySelector('[data-order-id]') ||
                          document.querySelector('[data-checkout-order]') ||
                          document.querySelector('.order-confirmation') ||
                          document.querySelector('[data-order-number]') ||
                          (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.order_id);

    if (!isCheckoutPage) {
      return;
    }

    // 尝试从页面获取订单数据
    let orderData = null;

    // 方法1: 从 Shopify 的订单数据中获取（订单确认页面）
    if (typeof window.Shopify !== 'undefined' && window.Shopify.checkout) {
      const checkout = window.Shopify.checkout;
      if (checkout.order_id || checkout.orderNumber) {
        orderData = {
          order_id: checkout.order_id || checkout.orderNumber || '',
          total_price: checkout.total_price || checkout.totalPrice || 0,
          currency: checkout.currency || 'USD',
          item_count: checkout.item_count || (checkout.line_items && checkout.line_items.length) || 1,
          line_items: checkout.line_items || []
        };
      }
    }

    // 方法2: 从页面中的 JSON-LD 数据获取
    if (!orderData) {
      try {
        const jsonLd = document.querySelector('script[type="application/ld+json"]');
        if (jsonLd) {
          const data = JSON.parse(jsonLd.textContent);
          if (data['@type'] === 'Order') {
            orderData = {
              order_id: data.orderNumber,
              total_price: data.totalPrice ? parseFloat(data.totalPrice) * 100 : 0,
              currency: data.priceCurrency || 'USD',
              item_count: data.numberOfItems || 1
            };
          }
        }
      } catch (e) {
        // 忽略错误
      }
    }

    // 方法3: 从 URL 参数或页面元素中获取
    if (!orderData) {
      const orderIdMatch = window.location.search.match(/order[_-]?id=([^&]+)/i) ||
                          window.location.pathname.match(/orders\/([^\/]+)/);
      if (orderIdMatch) {
        orderData = {
          order_id: orderIdMatch[1],
          total_price: 0, // 无法获取，使用 0
          currency: 'USD',
          item_count: 1
        };
      }
    }

    // 如果找到订单数据，发送事件
    if (orderData) {
      if (isPinterestLoaded()) {
        trackCheckoutSync(orderData);
      } else {
        waitForPinterestTag(function(loaded) {
          if (loaded) {
            trackCheckoutSync(orderData);
          } else {
            trackCheckoutWithFetch(orderData);
          }
        }, 10);
      }
    }
  }

  // 页面加载后检查订单确认页面
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndTrackCheckout);
  } else {
    checkAndTrackCheckout();
  }

  // 延迟检查（某些情况下订单数据可能延迟加载）
  setTimeout(checkAndTrackCheckout, 1000);
  setTimeout(checkAndTrackCheckout, 3000);
})();
